import { Box } from '@wix/design-system';
import React from 'react';
import { FixerType } from '../../types';
import { assertNever } from '../../utils/assert-never';
import { dataHooks } from '../../utils/datahooks';
import { ruleContentMapper } from '../../utils/rule-content-mapper';
import { isCustomFixer, isDropdownFixer, isEvergreenFixer, isInputFixer, isRadioGroupFixer, isToggleFixer } from '../../utils/rule-result-type-guard';
export const RuleContent = _ref => {
  let {
    ruleResult,
    selected
  } = _ref;
  if (isDropdownFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.DropdownRule];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  if (isInputFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.InputRule];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  if (isEvergreenFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.EvergreenRule];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  if (isCustomFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.Custom];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  if (isRadioGroupFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.RadioGroupRule];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      failedElementsComponent: ruleResult.fixerProps.failedElementsComponent,
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  if (isToggleFixer(ruleResult)) {
    const Component = ruleContentMapper[FixerType.ToggleRule];
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.ruleContent(ruleResult.ruleId)
    }, /*#__PURE__*/React.createElement(Component, {
      ruleResult: ruleResult,
      selected: selected
    }));
  }
  assertNever(ruleResult);
  return null;
};
//# sourceMappingURL=rule-content.js.map